declare namespace $ {

	type $mol_avatar__id_bog_wikilive_profile_page_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['player_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_string_button__value_bog_wikilive_profile_page_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['profile_name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_wikilive_profile_page_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_wikilive_profile_page_10 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['favorite_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_wikilive_profile_page_14 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['recent_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_profile_page_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_wikilive_profile_page_17 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['fav_row_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_profile_page_18 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['fav_row_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_profile_page_19 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['recent_row_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_profile_page_20 = $mol_type_enforce<
		ReturnType< $bog_wikilive_profile_page['recent_row_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_wikilive_profile_page extends $mol_page {
		player_id( ): string
		Avatar( ): $mol_avatar
		profile_name( next?: string ): string
		Name_edit( ): $mol_string_button
		stat_created( ): string
		Stat_created( ): $mol_view
		stat_edited( ): string
		Stat_edited( ): $mol_view
		stat_favorites( ): string
		Stat_favorites( ): $mol_view
		Stats( ): $mol_view
		Card( ): $mol_view
		Favorites_title( ): $mol_view
		favorite_rows( ): readonly(any)[]
		Favorites_list( ): $mol_list
		favorites_empty_text( ): string
		Favorites_empty( ): $mol_view
		Favorites_section( ): $mol_view
		Recent_title( ): $mol_view
		recent_rows( ): readonly(any)[]
		Recent_list( ): $mol_list
		recent_empty_text( ): string
		Recent_empty( ): $mol_view
		Recent_section( ): $mol_view
		fav_row_title( id: any): string
		fav_row_click( id: any, next?: any ): any
		recent_row_title( id: any): string
		recent_row_click( id: any, next?: any ): any
		store( ): $bog_wikilive_store
		title( ): string
		page_selected( next?: string ): string
		body( ): readonly(any)[]
		Fav_row( id: any): $mol_button_minor
		Recent_row( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=profile.view.tree.d.ts.map